module.exports = __webpack_public_path__ + "media/images/pc/top/clean_ribbon-570448031cddfcfd3d2d08f2ecb3d8bb.svg";